import StepBaseService from "../stepBase";
import StepBusinessType from "../stepBase/stepBusinessType";

class ChangePOStepService extends StepBaseService {
  // @ts-ignore
  getProcedureOwnerStepKey = () => {
    return {
      dataKey: StepBusinessType.procedureOwner.dataKey,
      settingKey: "getProcedureOwnerStepItem",
    };
  };

  // @ts-ignore
  getPrimaryProcedureOwnerStepKey = () => {
    return StepBusinessType.primaryProcedureOwner;
  };

  // @ts-ignore
  getPMPExcludedStepKey = () => {
    return StepBusinessType.pmpExcluded;
  };

  // @ts-ignore
  getTaskInfoKey = () => {
    return StepBusinessType.taskInfo;
  };

  // @ts-ignore
  getFlowStepData = () => null;
}

export default new ChangePOStepService();
